import { HTMLAttributes, useRef, useState } from 'react';
import { IRegisterOutputProps } from '@xmanscript/useform/lib/@types';
import { cn } from '@/utils';

interface INameEditProps extends HTMLAttributes<HTMLDivElement> {
  registerProps: IRegisterOutputProps;
  onEditStateChange?: (isEditing: boolean) => void;
}

export default function NameEdit({ className, registerProps, onEditStateChange, ...props }: INameEditProps) {
  const [isEditable, setIsEditable] = useState(false);
  const paraRef = useRef<HTMLParagraphElement | undefined>();

  return (
    <div className={cn('flex w-full flex-col items-center justify-center gap-2', className)} {...props}>
      <div className={cn('flex w-full  items-center justify-center gap-5', className)} {...props}>
        <p className="w-[6rem] text-[0.875rem] font-normal text-[#667085]">Name</p>
        <div className="flex w-full items-center justify-between gap-2  py-[0.38rem] pr-3">
          {!isEditable ? (
            <p
              // @ts-ignore
              ref={paraRef}
              className="flex-1 px-2 py-[2px] font-inter text-sm font-semibold text-[#475467]"
              style={{ borderBottom: '1px solid var(--Grey-G-400, #BDBDBD)' }}
            >
              {registerProps.value}
            </p>
          ) : (
            <input
              autoFocus
              type="text"
              tabIndex={0}
              {...registerProps}
              id="editable-input"
              className="bg-transparent p-2 font-inter text-base md:text-sm font-semibold text-[#475467] outline-none"
              style={{
                borderBottom: '1px solid var(--Grey-G-400, #BDBDBD)',
                width: paraRef ? `${paraRef.current?.clientWidth}px` : '100%',
              }}
            />
          )}
          <button
            onClick={() => {
              const newState = !isEditable;
              setIsEditable(newState);
              onEditStateChange?.(newState);

              const doc = document.getElementById('editable-input');
              doc?.focus();
            }}
            type="button"
            className="border-none p-2 outline-none"
          >
            <img src="/edit.svg" alt="edit" className="w-4 h-4" />
          </button>
        </div>
      </div>
      {registerProps.error && <p className="w-full text-left text-sm text-red-500">{registerProps.error}</p>}
    </div>
  );
}
